var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 158,
    viewBox: "0 0 160 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.0344 123.872C87.662 126.107 89.5428 128.564 91.1904 130.78C92.1897 129.611 93.2668 128.497 94.2437 127.314C95.0281 126.365 95.8378 125.289 96.7886 124.506C93.3642 123.785 89.5425 123.95 86.0344 123.872Z",
    fill: "#E5383B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7471 32.5088C62.8721 52.7588 78.9408 61.094 85.0574 74.0603C92.755 90.3781 91.9207 107.171 91.8144 123.975M86.0344 123.872C87.662 126.107 89.5428 128.564 91.1904 130.78C92.1897 129.611 93.2668 128.497 94.2437 127.314C95.0281 126.365 95.8378 125.289 96.7886 124.506C93.3642 123.785 89.5425 123.95 86.0344 123.872Z",
    stroke: "#E5383B",
    strokeWidth: 2.10831,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.b2115f46e947513aeb737471498ab47a.svg";
export { ForwardRef as ReactComponent };